/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MaintenanceTaskSummaryList
 */
export interface MaintenanceTaskSummaryList {
    /**
     * 
     * @type {number}
     * @memberof MaintenanceTaskSummaryList
     */
    active: number;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceTaskSummaryList
     */
    duesoon: number;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceTaskSummaryList
     */
    overdue: number;
}

export function MaintenanceTaskSummaryListFromJSON(json: any): MaintenanceTaskSummaryList {
    return MaintenanceTaskSummaryListFromJSONTyped(json, false);
}

export function MaintenanceTaskSummaryListFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaintenanceTaskSummaryList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': json['active'],
        'duesoon': json['duesoon'],
        'overdue': json['overdue'],
    };
}

export function MaintenanceTaskSummaryListToJSON(value?: MaintenanceTaskSummaryList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
        'duesoon': value.duesoon,
        'overdue': value.overdue,
    };
}


